export default __webpack_public_path__ + "static/reeddi-2684413f2cef1bb0a33a849bc0ff6736.png";